var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"numberInput",attrs:{"type":"text","placeholder":_vm.placeholder,"tabindex":_vm.tabindex},on:{"keydown":_vm.keydownHandler,"input":function($event){return _vm.normalizeValue($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }